import { createContainer } from 'unstated-next'

import { useIterable } from './useIterable'

/**
 * @deprecated We need to remove @iterable/web-sdk from our app and just hide Iterable events behind an API call. Maybe a server action in app directory.
 */
export const IterableContainer = createContainer(useIterable)
